import React from 'react';
import { useNavigate } from 'react-router-dom';
import AgilysysLogo from '../components/AgilysysLogo';
import { DiningIcon, GolfIcon, SpaIcon, PickleballIcon, SpecialEventsIcon, ResidentialIcon } from '../components/AreaIcons';
import blueTouchIcon from '../assets/blue-touch-icon.gif';

const VerticalLine = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="8" height="144" viewBox="0 0 8 144" fill="none">
    <path d="M4 4L4 140" stroke="#84BD00" strokeWidth="7" strokeLinecap="round"/>
  </svg>
);

const LandingPage = () => {
  const navigate = useNavigate();

  return (
    <div className="page splash landingPage">
      <div className="home-map">
        {/* Hotspot areas on the community map */}
        <div className="pickleball">
          <PickleballIcon onClick={() => navigate('/pickleball')} />
        </div>
        <div className="special-events">
          <SpecialEventsIcon onClick={() => navigate('/special-events')} />
        </div>
        <div className="residential">
          <ResidentialIcon onClick={() => navigate('/residential')} />
        </div>
        <div className="dining">
          <DiningIcon onClick={() => navigate('/dining')} />
        </div>
        <div className="golf">
          <GolfIcon onClick={() => navigate('/golf')} />
        </div>
        <div className="spa">
          <SpaIcon onClick={() => navigate('/spa')} />
        </div>
      </div>

      {/* Home icon top right */}
      
      <div className="root-home" onClick={() => { window.location.href = 'https://corp-headlesscms-dev.hospitalityrevolution.com/'; }}>
        <svg width="67" height="52" viewBox="0 0 67 52" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M32.5394 13.4865L11.1428 31.1091V50.1289C11.1428 50.6214 11.3384 51.0937 11.6866 51.4419C12.0349 51.7901 12.5072 51.9858 12.9996 51.9858L26.0045 51.9521C26.4953 51.9496 26.9653 51.7529 27.3115 51.405C27.6577 51.057 27.852 50.5861 27.852 50.0953V38.9879C27.852 38.4954 28.0477 38.0231 28.3959 37.6749C28.7441 37.3267 29.2164 37.131 29.7089 37.131H37.1362C37.6287 37.131 38.101 37.3267 38.4492 37.6749C38.7975 38.0231 38.9931 38.4954 38.9931 38.9879V50.0871C38.9923 50.3315 39.0398 50.5736 39.1328 50.7995C39.2257 51.0255 39.3624 51.2308 39.5349 51.4039C39.7074 51.5769 39.9123 51.7142 40.138 51.8079C40.3637 51.9016 40.6056 51.9498 40.8499 51.9498L53.8501 51.9858C54.3426 51.9858 54.8149 51.7901 55.1631 51.4419C55.5114 51.0937 55.707 50.6214 55.707 50.1289V31.0963L34.315 13.4865C34.0635 13.2838 33.7502 13.1732 33.4272 13.1732C33.1042 13.1732 32.7909 13.2838 32.5394 13.4865ZM66.3374 25.4643L56.6354 17.4671V1.39263C56.6354 1.02328 56.4887 0.669061 56.2275 0.407892C55.9663 0.146723 55.6121 0 55.2428 0H48.7438C48.3745 0 48.0203 0.146723 47.7591 0.407892C47.4979 0.669061 47.3512 1.02328 47.3512 1.39263V9.81921L36.961 1.27078C35.9639 0.45026 34.7127 0.00164022 33.4214 0.00164022C32.1301 0.00164022 30.8789 0.45026 29.8818 1.27078L0.505408 25.4643C0.364389 25.5808 0.247719 25.724 0.162063 25.8857C0.0764066 26.0473 0.0234435 26.2243 0.00619971 26.4064C-0.0110441 26.5886 0.00776933 26.7723 0.061565 26.9472C0.115361 27.122 0.203084 27.2846 0.319723 27.4255L3.27906 31.0232C3.39539 31.1646 3.53846 31.2817 3.7001 31.3678C3.86174 31.4539 4.03877 31.5072 4.22105 31.5248C4.40334 31.5424 4.5873 31.5238 4.7624 31.4702C4.93751 31.4166 5.10032 31.329 5.24151 31.2123L32.5394 8.72832C32.7909 8.5256 33.1042 8.41506 33.4272 8.41506C33.7502 8.41506 34.0635 8.5256 34.315 8.72832L61.6141 31.2123C61.755 31.329 61.9176 31.4167 62.0924 31.4705C62.2673 31.5243 62.451 31.5431 62.6332 31.5259C62.8153 31.5086 62.9923 31.4557 63.1539 31.37C63.3156 31.2844 63.4588 31.1677 63.5754 31.0267L66.5347 27.429C66.6512 27.2873 66.7386 27.1239 66.7917 26.9482C66.8449 26.7726 66.8628 26.5882 66.8445 26.4056C66.8261 26.2231 66.7719 26.0459 66.6849 25.8843C66.5979 25.7228 66.4798 25.58 66.3374 25.4643Z"/>
        </svg>
      </div>

      {/* Top left text content */}
      <div className="top-left">
        <div className="topic-header">
          Maximize Return on Experience
          {'\n'}
          <span className="sub-topic-header">
            For <strong>Residential Life Communities</strong>
          </span>
        </div>
        <div className="column">
          <div className="row"><span>Delight</span> residents</div>
          <div className="row"><span>Retain</span> staff</div>
          <div className="row"><span>Grow</span> margins</div>
          <div className="line">
            <VerticalLine />
          </div>
        </div>
      </div>

      {/* Bottom left call to action */}
      <div className="bottom-left">
        <img
          className="touch-prompt"
          src={blueTouchIcon}
          alt="Touch to begin"
        />
        <div className="block">
          {"Explore our interactive\nResidential Life Community map to discover\nwhere "}
          <span>personal</span>
          {" meets "}
          <span>profitable</span>
          {"\n"}
          <strong>Touch an area to begin!</strong>
        </div>
      </div>

      {/* Bottom right logo */}
      <div className="bottom-right-logo" onClick={() => navigate('/aboutus')}>
        <AgilysysLogo />
      </div>
    </div>
  );
};

export default LandingPage;
